import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// PRODUCTION OAuth callback: the backend (/auth/google/callback) sets the
// session cookie and redirects here with ?token=... . We verify via /auth/me.
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      console.error('No token found in callback URL');
      navigate('/login?error=no_token', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
        const userData = res.data;
        if (userData && userData.user_id) {
          setUser(userData);
          window.history.replaceState(null, '', window.location.pathname);
          navigate(userData.profile_complete ? '/dashboard' : '/profile-setup', { replace: true });
        } else {
          navigate('/login?error=auth_failed', { replace: true });
        }
      } catch (e) {
        console.error('Auth callback failed', e);
        navigate('/login?error=auth_failed', { replace: true });
      }
    })();
  }, [location.search, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950">
      <div className="animate-spin w-8 h-8 border-2 border-yellow-400 border-t-transparent rounded-full" />
    </div>
  );
}
